import cx from 'classnames';
import React from 'react';

import { AnimateInView } from '../../components/animation/AnimateInView';
import { ButtonProps } from '../../components/buttons/Button';
import { FigCaption } from '../../components/images/FigCaption';
import { Content, ContentProps } from '../../components/module/Content';
import { Title } from '../../components/module/Title';
import { Wrapper } from '../../components/module/Wrapper';
import { VideoMemo as VideoComponent } from '../../components/video/Video';
import { ThemeType, VideoType } from '../../types';

export type VideoProps = {
  title?: string;
  intro?: ContentProps['children'];
  buttons?: ButtonProps[];
  video?: VideoType;
  theme?: ThemeType;
};

export const Video = ({ title, intro, buttons, theme, video }: VideoProps) => {
  return (
    <div className="bg-white px-10">
      <div className="rounded-xl overflow-hidden">
        <Wrapper theme={theme} id={title}>
          <div className="text-center">
            {title && (
              <AnimateInView y={30}>
                <Title as="h2" size="xl" weight="extrabold" color={theme?.title}>
                  {title}
                </Title>
              </AnimateInView>
            )}

            {(buttons || intro) && (
              <AnimateInView className="mt-4 sm:mt-6 mx-auto" y={30}>
                <Content buttons={buttons} color={theme?.text} align="center">
                  {intro}
                </Content>
              </AnimateInView>
            )}

            {video && (
              <AnimateInView className="mt-4 sm:mt-6 mx-auto">
                <figure>
                  <div
                    className={cx('overflow-hidden rounded-md', {
                      'relative aspect-video': video.frameless,
                    })}
                  >
                    <VideoComponent {...video} />
                  </div>

                  {video?.caption && (
                    <div className="mt-3">
                      <FigCaption caption={video.caption} />
                    </div>
                  )}
                </figure>
              </AnimateInView>
            )}
          </div>
        </Wrapper>
      </div>
    </div>
  );
};

export const VideoMemo = React.memo(Video);
